<template>
  <div class="menu-tabs">
    <a v-for="(item, index) in menuNavigations" :key="`menu-tab-item-${index}`"
       :class="['tab-item', { active: activeTab == item.route }, { 'border-first': item.first }, { 'border-last': item.last}]"
       @click="goto(item)"
    >
      <i :class="['icon', item.icon]" />
      <span class="lg:hidden">{{ item.labelDesktop }}</span>
      <span class="hidden lg:block">{{ item.labelMobile }}</span>
    </a>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: ['data'],
  data() {
    return {
      menuNavigations: [
        {
          icon: 'icon-bor-information',
          labelDesktop: '基本情報',
          labelMobile: '基本情報',
          active: true,
          route: '/bs-02-001',
          query: this.$route.query
        },
        {
          icon: 'icon-bor-plan',
          labelDesktop: 'プラン',
          labelMobile: 'プラン',
          active: false,
          route: '/bs-pnl-02-001',
          query: this.$route.query
        },
        {
          icon: 'icon-bor-img',
          labelDesktop: 'フォトギャラリー',
          labelMobile: 'フォト',
          active: false,
          route: '/bs-men-02-020',
          query: this.$route.query
        },
        {
          icon: 'icon-bor-care',
          labelDesktop: '設備・サービス詳細',
          labelMobile: '設備・詳細',
          active: false,
          route: '/bs-men-02-030',
          query: this.$route.query
        }
        // {
        //   icon: 'icon-bor-bubble',
        //   labelDesktop: 'クチコミ',
        //   labelMobile: 'クチコミ',
        //   active: false,
        //   route: '/bs-men-02-040',
        //   query: this.$route.query
        // }
      ]
    }
  },
  mounted() {
    if (this.data) {
      this.menuNavigations = _.cloneDeep(this.data)
    }
  },
  computed: {
    activeTab() {
      return this.$route.path
    }
  },
  methods: {
    goto(nav) {
      if (nav.route) {
        const query = nav.query ? nav.query : {}
        this.$router.push({path: nav.route, query})
      } else if (nav.href) {
        if (nav._bank) {
          window.open(nav.href)
        } else {
          location.href(nav.href)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
